import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import LandingPage from "./pages/LandingPage";
import ChatPage from "./pages/ChatPage";
import NetworkPage from "./pages/NetworkPage";
import SharedViewPage from "./pages/SharedViewPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsPage from "./pages/TermsPage";
import SignupPage from "./pages/SignupPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import GiaPage from "./pages/GiaPage";
import GynovateSocialPage from "./pages/GynovateSocialPage";
import GynovateMDPage from "./pages/GynovateMDPage";
import GynovateHealthPage from "./pages/GynovateHealthPage";
import GynovatePersonalPage from "./pages/GynovatePersonalPage";
import Gynovate2030Page from "./pages/Gynovate2030Page";
import AdminPage from "./pages/AdminPage";
import DisclaimerPage from "./pages/DisclaimerPage";
import PrivacyPage from "./pages/PrivacyPage";
import CookieConsent from "./components/CookieConsent";
import PWAInstallBanner from "./components/PWAInstallBanner";

function RequireSignup({ children }) {
  const signup = localStorage.getItem('gynovate_signup');
  const cookie = document.cookie.split(';').some(c => c.trim().startsWith('gynovate_signed='));
  if (!signup && !cookie) {
    return <Navigate to="/signup" replace />;
  }
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/chat" element={<RequireSignup><ChatPage /></RequireSignup>} />
          <Route path="/chat/:sessionId" element={<RequireSignup><ChatPage /></RequireSignup>} />
          <Route path="/network" element={<RequireSignup><NetworkPage /></RequireSignup>} />
          <Route path="/shared/:shareId" element={<SharedViewPage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/payment/success" element={<PaymentSuccessPage />} />
          <Route path="/gia" element={<GiaPage />} />
          <Route path="/social" element={<RequireSignup><GynovateSocialPage /></RequireSignup>} />
          <Route path="/md" element={<RequireSignup><GynovateMDPage /></RequireSignup>} />
          <Route path="/health" element={<RequireSignup><GynovateHealthPage /></RequireSignup>} />
          <Route path="/personal" element={<RequireSignup><GynovatePersonalPage /></RequireSignup>} />
          <Route path="/2030" element={<RequireSignup><Gynovate2030Page /></RequireSignup>} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/disclaimer" element={<DisclaimerPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <CookieConsent />
        <PWAInstallBanner />
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
